module.exports = __webpack_public_path__ + "static/media/move_container_to_load.233d7093.svg";